module.exports = __webpack_public_path__ + "static/img/v21TwoBg-p.ba77694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21TwoBg-p.png
// module id = mie3
// module chunks = 1